import { supabase } from '@/lib/supabase'
import { SUPPORTED_TIMEFRAMES } from '@/shared/utils/timeframes'

export type PlanRow = { id: string; name: string }
export type PlanPushPolicy = { plan_id: string; push_enabled: boolean; allowed_timeframes: string[] }
export type PlanWithPolicy = PlanRow & PlanPushPolicy

function sanitizeTfs(arr: string[]): string[] {
  const set = new Set(arr.map((t) => String(t).toUpperCase()))
  const out: string[] = []
  for (const t of SUPPORTED_TIMEFRAMES) if (set.has(String(t).toUpperCase())) out.push(t)
  return out
}

export async function listPlansWithPolicy(): Promise<PlanWithPolicy[]> {
  const { data: plans, error: e1 } = await supabase.from('plans').select('id,name,active').order('name', { ascending: true })
  if (e1) throw e1
  const active = (plans || []).filter((p: any) => p.active !== false).map((p: any) => ({ id: String(p.id), name: String(p.name || p.id) }))
  const { data: pols, error: e2 } = await supabase.from('plan_push_policies').select('plan_id,push_enabled,allowed_timeframes')
  if (e2) throw e2
  const map = new Map<string, any>((pols || []).map((r: any) => [String(r.plan_id), r]))
  return active.map((p) => ({
    id: p.id,
    name: p.name,
    plan_id: p.id,
    push_enabled: map.get(p.id)?.push_enabled === true,
    allowed_timeframes: sanitizeTfs(map.get(p.id)?.allowed_timeframes || []),
  }))
}

export async function upsertPlanPolicy(plan_id: string, push_enabled: boolean, allowed_timeframes: string[]): Promise<void> {
  const clean = sanitizeTfs(allowed_timeframes)
  const rows = [{ plan_id, push_enabled: !!push_enabled, allowed_timeframes: clean }]
  const { error } = await supabase.from('plan_push_policies').upsert(rows as any, { onConflict: 'plan_id' })
  if (error) throw error
}

export function getSupportedTimeframes(): string[] {
  return SUPPORTED_TIMEFRAMES.slice()
}

